import { Stack, Text } from '@mantine/core';
import type { ReactNode } from 'react';

type Props = {
  title: string;
  description?: string;
  children: ReactNode;
};

/** Groupe de champs du formulaire SUS : `fieldset` nommé par un titre visible. */
const SusFormSection = ({ title, description, children }: Props) => (
  <Stack gap="xs" component="fieldset" p={0} m={0} bd={0}>
    <Text component="legend" fw={700} size="lg" c="var(--mantine-primary-color-filled)" pb={4}>
      {title}
    </Text>
    {description && (
      <Text size="xs" c="dimmed">
        {description}
      </Text>
    )}
    {children}
  </Stack>
);

export default SusFormSection;
